<template>
  <span class="text-xs text_color cursor-pointer w-full" @click="click">
    {{ formatDate(sentOn) }}
  </span>
</template>
<script setup>
import { defineProps } from "vue";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  row: {
    type: Object,
    required: true,
  },
});

const sentOn = new Date(props.value);

function formatDate(date) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  hours = hours % 12;
  hours = hours ? hours : 12; // If hours is 0, make it 12

  return `${day} ${month} ${year} ${hours}:${minutes}${ampm}`;
}

const click = () => {
  eventBus.emit("emails/showActivity", props.row);
};
</script>
